import React from 'react';
import Button from './Button';
import ZoomInIcon from '../../images/Icon20_ZoomIn.svg';
import ZoomOutIcon from '../../images/Icon20_ZoomOut.svg';
import FitIcon from '../../images/Icon20_ZoomFitScreen.svg';
import FullScreenIcon from '../../images/Icon20_ZoomFullScreen.svg';
import { __ } from '../../../../core/utils';

export const OSDTools = ({ viewer }) => {
  const osdTools = [
    {
      id: 'zoomIn',
      icon: ZoomInIcon,
      extraClass: ['roundedUp'],
      onClick: () => {
        viewer.viewport.zoomBy(1.2);
        viewer.viewport.applyConstraints();
      },
    },
    {
      id: 'zoomOut',
      icon: ZoomOutIcon,
      onClick: () => {
        viewer.viewport.zoomBy(0.8);
        viewer.viewport.applyConstraints();
      },
    },
    {
      id: 'fit',
      icon: FitIcon,
      onClick: () => {
        viewer.viewport.goHome();
      },
    },
    {
      id: 'fullscreen',
      icon: FullScreenIcon,
      extraClass: ['withSpacer'],
      onClick: () => {
        viewer.setFullScreen(!viewer.isFullPage());
      },
    },
  ];

  return osdTools.map(({ id, icon, onClick, extraClass }) => (
    <Button
      key={id}
      id={id}
      icon={icon}
      onClick={onClick}
      extraClass={[extraClass]}
      label={__('canvas.toolbar.' + id)}
    />
  ));
};
